import { Box, Text, TextButton } from '@wix/design-system';
import React from 'react';
import { dataHooks } from '../../../utils/datahooks';
export const ToggleFixerCompletedState = _ref => {
  let {
    ruleResult,
    description,
    onEditClick,
    children
  } = _ref;
  const dataHook = dataHooks.completedTaskToggleFixer(ruleResult.dataHook);
  const completedRuleContent = ruleResult.fixerProps.completedRuleContent;
  const {
    title,
    editButtonLabel
  } = completedRuleContent;
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHooks.completedTaskContainer(dataHook),
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, /*#__PURE__*/React.createElement(Box, {
    align: "space-between",
    direction: "horizontal",
    marginTop: "SP2"
  }, description, ruleResult.isEditableOnceCompleted && onEditClick && /*#__PURE__*/React.createElement(TextButton, {
    dataHook: dataHooks.completedTaskEditButton(dataHook),
    ellipsis: true,
    size: "tiny",
    weight: "normal",
    onClick: onEditClick
  }, editButtonLabel))), children);
};
//# sourceMappingURL=toggle-rule-completed-state.js.map